import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FrDatePicker from '../components/FrDatePicker';
import FrameF2 from '../components/FrameF2'

import api from '../services/api'
import { dateSql, paramsToObject, getUserCode } from '../utils/functions'
import { mMoeda } from '../utils/masks';

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';
import FrSelect from '../components/FrSelect'

const swal = withReactContent(Swal)

function Nota_Fiscal() {
  const [data, setData] = useState({})
  const [enableEdit, setEnableEdit] = useState('S')
  const [comboTnf, setComboTnf] = useState([{ value: '', display: '' }])
  const [nomePac, setNomePac] = useState('')
  const [comboTom, setComboTom] = useState([{ value: '', display: '' }])
  const [tom, setTom] = useState('')

  useEffect(() => {
    const fetchData = async () => {

      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      setComboTom(await api.getComboData('tomador'))
      setComboTnf(await api.getComboData('tipo_nota'))

      api.get('/nota_fiscal?pk_ntf=' + query.codigo).then(async r => {
        r.data[0].valor_bruto = mMoeda(r.data[0].valor_bruto.toFixed(2))
        r.data[0].valor_liquido = mMoeda(r.data[0].valor_liquido.toFixed(2))
        if (r.data[0].valor_pis)
          r.data[0].valor_pis = mMoeda(r.data[0].valor_pis.toFixed(2))

        if (r.data[0].valor_cofins)
          r.data[0].valor_cofins = mMoeda(r.data[0].valor_cofins.toFixed(2))

        if (r.data[0].valor_csll)
          r.data[0].valor_csll = mMoeda(r.data[0].valor_csll.toFixed(2))

        if (r.data[0].valor_iss)
          r.data[0].valor_iss = mMoeda(r.data[0].valor_iss.toFixed(2))

        if (r.data[0].valor_ir)
          r.data[0].valor_ir = mMoeda(r.data[0].valor_ir.toFixed(2))

        setData(r.data[0])

        setNomePac(r.data[0].nomepac)

        swal.close()
      })
    }


    fetchData()
  }, [])



  useEffect(() => {
    const fetchData = () => {
      const auxValues = { ...data };
      let valorPis = 0
      let valorCofins = 0
      let valorIr = 0
      let valorCsll = 0
      let valorIss = 0

      try {
        valorPis = parseFloat(data.valor_pis.replace(',', '.'))
      } catch (error) {
        if (data.valor_pis)
          valorPis = parseFloat(data.valor_pis)
        else
          valorPis = 0
      }

      try {
        valorCofins = parseFloat(data.valor_cofins.replace(',', '.'))
      } catch (error) {
        if (data.valor_cofins)
          valorCofins = parseFloat(data.valor_cofins)
        else
          valorCofins = 0
      }

      try {
        valorIr = parseFloat(data.valor_ir.replace(',', '.'))
      } catch (error) {
        if (data.valor_ir)
          valorIr = parseFloat(data.valor_ir)
        else
          valorIr = 0

      }

      try {
        valorCsll = parseFloat(data.valor_csll.replace(',', '.'))
      } catch (error) {
        if (data.valor_csll)
          valorCsll = parseFloat(data.valor_csll)
        else
          valorCsll = 0
      }

      try {
        valorIss = parseFloat(data.valor_iss.replace(',', '.'))
      } catch (error) {
        if (data.valor_iss)
          valorIss = parseFloat(data.valor_iss)
        else
          valorIss = 0

      }

      let vBruto = data.valor_bruto

      try {
        vBruto = data.valor_bruto.replace('.', '')
        vBruto = vBruto.replace(',', '.')
        vBruto = parseFloat(vBruto)
      } catch (error) {
        vBruto = 0
      }

      let valorLiquido = vBruto - valorPis - valorCofins - valorIr - valorCsll - valorIss
      auxValues['valor_liquido'] = mMoeda(valorLiquido.toFixed(2))
      setData(auxValues)
    }

    fetchData()
  }, [data.valor_bruto, data.valor_pis, data.valor_cofins, data.valor_csll, data.valor_ir, data.valor_iss])




  function consistData(data) {
    let required = [
      'fk_tom',
      'fk_tnf',
      'data_emissao',
      'valor_bruto',
      'descricao'
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr

      if (curr === "fk_tom") fieldName = "Tomador";
      if (curr === "fk_tnf") fieldName = "Tipo de Nota";
      if (curr === "data_emissao") fieldName = "Data de Emissão";
      if (curr === "valor_bruto") fieldName = "Valor Bruto";
      if (curr === "descricao") fieldName = "Descrição do Serviço";


      if (!data[curr]) return errors.push(fieldName)
    })

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Confirma edição da nota?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        let errors = consistData(auxValues)

        const urlParams = new URLSearchParams(window.location.search);
        let query = paramsToObject(urlParams)

        auxValues['data_emissao'] = dateSql(auxValues['data_emissao'])
        auxValues['fk_usu'] = getUserCode()

        if (errors.length === 0) {
          api.post('/nota_fiscal/edit', auxValues).then(r => {
            if (r.status === 200) {
              swal.fire({
                title: 'Nota fiscal alterada',
                text: "Nota fiscal alterada com sucesso!",
                icon: 'success',
              }).then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
            } else {
              swal.fire({
                title: 'Erro!',
                text: "Nota fiscal não foi alterada!",
                icon: 'warning',
              })
            }
          })
        }
        else {
          swal.fire({
            title: 'Erro!',
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }


      }
    })
  }


  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }


  useEffect(() => {
    const fetchCad = async () => {

      setComboTom(await api.getComboData('tomador'))

      const auxValues = { ...data };

      if (tom > 0) {
        auxValues['fk_tom'] = tom;

        setData(auxValues);
      }
    }
    fetchCad()
  }, [tom])


  const handleChange = async (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {

      case 'valor_pis':
      case 'valor_cofins':
      case 'valor_ir':
      case 'valor_csll':
      case 'valor_iss':
      case 'valor_liquido':
      case 'valor_bruto':
        auxValues[e.target.name] = mMoeda(e.target.value);
        break;


      case 'fk_tom':
      case 'tom': {
        auxValues['fk_tom'] = e.target.value;
        setTom(e.target.value)
        break


      }
      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };

  return (
    <div className="defaultReg">
      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>Edição de Nota</h3>
          <UserOptions />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>


          <FrTextInput
            maxLength='150'
            value={nomePac || ''}
            color='#c0c0c0'
            label='Residente'
            variant='outlined'
            size='small'
            style={{ width: 350 }}
          // disabled
          />
          <br />
          <div class="container-fluid">
            <div class="row" >

              <div class="column">

                <FrSelect
                  value={data.fk_tom || ''}
                  onChange={handleChange}
                  name="fk_tom"
                  id="fk_tom"
                  label='Tomador'
                  data={comboTom}
                  style={{ width: 350 }}
                />
              </div>
              <div class="column" >
                <FrameF2 tipoModal={'Tomador'} data={data} cad={tom} setCad={setTom} ></FrameF2>
              </div>
            </div>
          </div>


          <FrDatePicker
            value={(data.data_emissao || "").split("T")[0]}
            onChange={handleChange}
            name="data_emissao"
            id="data_emissao"
            color="#528b46"
            label="Data Emissão"
            variant="outlined"
            size="small"
            style={{ width: 190 }}
          />


          <FrSelect
            value={data.fk_tnf || ''}
            onChange={handleChange}
            name="fk_tnf"
            id="fk_tnf"
            label='Tipo de Nota'
            data={comboTnf}
            style={{ width: 300 }}
          />

          <br />
          <FrTextInput
            maxLength='150'
            value={data.valor_bruto || ''}
            name='valor_bruto'
            id='valor_bruto'
            color='#c0c0c0'
            label='Valor Bruto'
            variant='outlined'
            size='small'
            style={{ width: 120 }}
          />

          <FrTextInput
            maxLength='150'
            value={data.valor_iss || ''}
            onChange={handleChange}
            name='valor_iss'
            id='valor_iss'
            color='#c0c0c0'
            label='Retenção ISSQN'
            variant='outlined'
            size='small'
            style={{ width: 120 }}
          />

          <FrTextInput
            maxLength='150'
            value={data.valor_ir || ''}
            onChange={handleChange}
            name='valor_ir'
            id='valor_ir'
            color='#c0c0c0'
            label='Retenção IRRF'
            variant='outlined'
            size='small'
            style={{ width: 120 }}
          />

          <FrTextInput
            maxLength='150'
            value={data.valor_pis || ''}
            onChange={handleChange}
            name='valor_pis'
            id='valor_pis'
            color='#c0c0c0'
            label='Retenção PIS'
            variant='outlined'
            size='small'
            style={{ width: 120 }}
          />


          <FrTextInput
            maxLength='150'
            value={data.valor_cofins || ''}
            onChange={handleChange}
            name='valor_cofins'
            id='valor_cofins'
            color='#c0c0c0'
            label='Retenção COFINS'
            variant='outlined'
            size='small'
            style={{ width: 120 }}
          />


          <FrTextInput
            maxLength='150'
            value={data.valor_csll || ''}
            onChange={handleChange}
            name='valor_csll'
            id='valor_csll'
            color='#c0c0c0'
            label='Retenção CSLL'
            variant='outlined'
            size='small'
            style={{ width: 120 }}
          />

          <FrTextInput
            maxLength='150'
            value={data.valor_liquido || ''}
            name='valor_liquido'
            id='valor_liquido'
            color='#c0c0c0'
            label='Valor Líquido'
            variant='outlined'
            size='small'
            style={{ width: 120 }}
          />


          <br />
          <FrTextInput
            maxLength='500'
            value={data.descricao || ''}
            onChange={handleChange}
            name="descricao"
            id="descricao"
            color="#528b46"
            label="Descrição do Serviço"
            variant="filled"
            size="small"
            style={{ width: 530 }}
            multiline
            rows="8"
            rowsMax="8"
            fullWidth
          />

          <br />
          <FrTextInput
            maxLength='500'
            value={data.observacao || ''}
            onChange={handleChange}
            name="observacao"
            id="observacao"
            color="#528b46"
            label="Observações"
            variant="filled"
            size="small"
            style={{ width: 530 }}
            multiline
            rows="8"
            rowsMax="8"
            fullWidth
          />

        </form>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Confirmar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Nota_Fiscal;
